// TODO: PackingTypeCreate.tsx content
export {};
import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import LazyLoading from '../../../components/LazyLoading';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { PackingType } from '../../../app/models/PackingType';
import usePackingTypeService from '../../../app/services/hooks/usePackingTypeService';
import PackingTypeForm from './forms/PackingTypeForm';
import { ServiceResponse } from '../../../app/services/shared/interfaces';

const PackingTypeCreate = ({ onSaved, onCancel, onError }: any) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [packingType, setPackingType] = useState<PackingType>({ name: '', category: '' });
    const [errorFields, setErrorFields] = useState<any>();
    const { storePackingType, fetchingStorePackingType } = usePackingTypeService();

    const store = () => {
        if (showLoading) showLoading('loading', 'Saving packing type...');
        storePackingType(packingType, {
            onSuccess: (response: ServiceResponse) => {
                hideLoading?.();
                useReactConfirmAlert().successAlert({ title: 'Éxito', message: response.message });
                toast.success(response.message);
                onSaved?.();
            },
            onError: (response: ServiceResponse) => {
                hideLoading?.();
                useReactConfirmAlert().errorAlert({ title: 'Error', message: response.message });
            },
            onFieldError: (response: ServiceResponse) => {
                hideLoading?.();
                setErrorFields(response.data);
            },
        });
    };

    return (
        <>
            <PackingTypeForm packingType={packingType} setPackingType={setPackingType} errorFields={errorFields} />
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={onCancel} locked={fetchingStorePackingType} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStorePackingType} />
                </div>
            </div>
        </>
    );
};

export default PackingTypeCreate;